import type { CatalogEvent } from "./types";

export function sortCatalogEvents(events: CatalogEvent[]): CatalogEvent[] {
  return [...events].sort((a, b) =>
    a.event_date.localeCompare(b.event_date)
    || a.city_name.localeCompare(b.city_name, "de")
    || a.locality.localeCompare(b.locality, "de"),
  );
}

export function isEventActionable(event: CatalogEvent): boolean {
  return event.has_pdf || Boolean(event.map_token);
}
